module.exports = __webpack_public_path__ + "static/img/ent-detail-18.ca41ea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-18.jpg
// module id = GPjh
// module chunks = 51